interface RoundedIconProps {
  icon: JSX.Element
  className?: string
}

const RoundedIcon = ({ icon, className = '' }: RoundedIconProps) => (
  <div
    className={`h-16 w-16 rounded-full shrink-0 flex justify-center items-center bg-green-100 ${className}`}
  >
    {icon}
  </div>
)

export default RoundedIcon
